import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
import {getStorage} from 'firebase/storage';

const firebaseConfig = {

  apiKey: "AIzaSyCSYA1Ugva8crlrTy2dIdqzY4XDjyBfWo0",
  authDomain: "emytodev.firebaseapp.com",
  projectId: "emytodev",
  storageBucket: "emytodev.appspot.com",
  messagingSenderId: "1048572094870",
  appId: "1:1048572094870:web:040a66f2d881a65ea355b7",
  measurementId: "G-J8XVV9Y285"

};


// Initialize Firebase

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storages = getStorage(app);